import React, {ReactNode} from 'react';
import useUserInfoApi from '@vp-shared/domain/userinfo/useUserInfoApi';
import {UserInformation} from '../types/UserInformation';

type UserInformationContextType = UserInformation & {
  api?: {
    isLoading: boolean;
    fetchData: () => void;
    error: Record<string, unknown> | string | null;
    attempted: boolean;
    saveAttempted: boolean;
  };
};

const DEFAULT_CONTEXT_DATA = {};

const UserInformationContext =
  React.createContext<UserInformationContextType>(DEFAULT_CONTEXT_DATA);

const DEFAULT_FETCH_OPTS = {sender: 'UserInformationProvider'};

type Props = {
  children: ReactNode;
  apiUrl: string;
};
/**
 * @deprecated use UserInformationQueryProvider instead if possible
 */
const UserInformationProvider = ({children, apiUrl}: Props) => {
  const apiSpec = {
    url: `${apiUrl}/userInformation`,
    method: 'GET',
    normalizer: (data: object) => data as UserInformation
  };
  const {data, ...rest} = useUserInfoApi([apiSpec], DEFAULT_FETCH_OPTS);

  const userData: UserInformation = (data || {}) as UserInformation;

  return (
    <UserInformationContext.Provider value={{...userData, api: {...rest}}}>
      {children}
    </UserInformationContext.Provider>
  );
};

export {UserInformationProvider as default, UserInformationContext};
